module.exports = __webpack_public_path__ + "img/started.5ec13812.png";